import { Directive, Renderer2, DOCUMENT, inject } from '@angular/core';

// TODO deprecate that and use ScrollLockService from commit 37696719bf13a5e721b9ed8d83b34ac9cc902fb3
@Directive({
  selector: '[tdWbDocumentNoScroll]',
  exportAs: 'tdWbDocumentNoScroll'

})
export class DocumentNoScrollDirective {
  private readonly renderer = inject(Renderer2);
  private readonly document = inject<Document>(DOCUMENT);

  disableScroll(opened: boolean): void {
    if (opened) {
      this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
    } else {
      this.renderer.removeStyle(this.document.body, 'overflow');
    }
  }
}
